import http from '../http-common'

const getAll = () => {
  return http.get('/project-roles')
}

export const projectRolesService = {
    getAll,
}
